import { createSelector } from '@ngrx/store';
import { SelectSharedState } from '../shared.selectors';

export const SelectErrorState = createSelector(SelectSharedState, state => state.errorState);
export const SelectErrorMessages = createSelector(SelectErrorState, state => state.messages);
